export default "__VITE_ASSET__BpSjADcV__"